export default "__VITE_ASSET__Y_akHbf4__"